export default __webpack_public_path__ + "static/sorgalu-videoMiseEnAvant-093988421ee2e79d9ab981b3f7b27733.mp4";